import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IonicModule } from '@ionic/angular';
import { TitleContentComponent, CustomValidatorModule } from 'ngx-zcs-components';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

import { HeatpumpConfigComponent } from './heatpump-config.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { AzzurroHubRescanComponent } from '../components/azzurro-hub-rescan/azzurro-hub-rescan.component';

@NgModule({
  declarations: [
    HeatpumpConfigComponent,
  ],
  exports: [
    HeatpumpConfigComponent,
  ],
  imports: [
    AzzurroHubRescanComponent,
    BlockTitleComponent,
    CommonModule,
    CustomValidatorModule,
    IonicModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    TitleContentComponent,
  ]
})
export class HeatpumpConfigModule { }
